// @flow strict

import React from 'react';

import * as styles from './youtube.module.less';

/**
 * Type of component properties
 */
type YoutubePlayerProps = {
  id: string,
  title: string,
  description: string,
  uploaddate: string,
};

/**
 * Render youtube iframe for passed video id.
 *
 * @param {string} id - ID of youtube video
 *
 * @returns {Node}
 */
export const YoutubePlayer = ({ id }: YoutubePlayerProps) => {
  return (
    <div className={styles.embedContainer}>
      <iframe
        src={`https://www.youtube.com/embed/${id}`}
        frameBorder="0"
        allowFullScreen=""
      />
    </div>
  );
};
